module.exports = __webpack_public_path__ + "img/ZHWLRJKF_2 - 副本.feca5bf0.jpg";